import styled from 'styled-components';
import { breakpoints } from '@/styles/breakpoints';

const StyledSearch = styled.div`
  width: 110%;

  ${breakpoints.MD} {
    width: 68%;
    margin-left: auto;
    margin-top: 10px;
  }

  ${breakpoints.MDL} {
    width: 90%;
  }

  ${breakpoints.LG} {
    width: 57%;
    margin-top: 20px;
  }
`;

export { StyledSearch };
